export default __webpack_public_path__ + "static/services-details1f-8fee717c6cba026b17e2a42cd22b4ad8.jpg";